import PageHeader from "../header";
import PageLoading from "../PageLoading";
import { useLocation } from "react-router-dom";
import {
  getAdminPageContentClassName,
  getContentEditorAdminLayoutState,
} from "../../utils/contentEditorAdminLayout";
import "../../style/promptGeneration.css";

/**
 * Admin layout shell with loading spinner in content area.
 * Used as Suspense fallback for admin routes so header stays visible
 * during lazy load, preventing broken layout on hard refresh.
 */
function AdminPageLoading() {
  const location = useLocation();
  const layout = getContentEditorAdminLayoutState(location);

  return (
    <div className="admin-page">
      <PageHeader />
      <div className="admin-page-sidebar-and-content">
        <div className={getAdminPageContentClassName(layout)}>
          <PageLoading />
        </div>
      </div>
    </div>
  );
}

export default AdminPageLoading;
